import { useEffect } from 'react';
import { useAngularService } from './get_angular_service';

export function useOnRouteChange(callback: () => void) {
  const $rootScope = useAngularService('$rootScope');

  useEffect(() => {
    const unsubscribe = $rootScope.$on('$stateChangeSuccess', () => {
      callback();
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
